import "./Home.css";
import "../../styles/App.css";
import Navbar from "../../components/Navbar/Navbar.js";
import Footer from "../../components/Footer/Footer.js";


function Home() {
    return (
        <div className="Home-Page">
            <Navbar />
            <h1 className="heading">Home Page</h1>
            <p>Welcome to the Home Page!</p>
            <Footer />  
        </div>
    );
}

export default Home;